import { render, staticRenderFns } from "./jessibuca.vue?vue&type=template&id=73670c0d&scoped=true&"
import script from "./jessibuca.vue?vue&type=script&lang=js&"
export * from "./jessibuca.vue?vue&type=script&lang=js&"
import style0 from "./jessibuca.vue?vue&type=style&index=0&id=73670c0d&prod&lang=css&"
import style1 from "./jessibuca.vue?vue&type=style&index=1&id=73670c0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73670c0d",
  null
  
)

export default component.exports